export const FILES_CELL_COPY_TTL_MS = 2 * 60 * 60 * 1000

export function isFilesCellBeingCopied(value: unknown, now: number = Date.now()): boolean {
  const cellValue = value as {isBeingCopied?: boolean, copyStartedAt?: string} | null | undefined
  if(cellValue?.isBeingCopied !== true) {
    return false
  }
  if(!cellValue.copyStartedAt) {
    return true
  }
  return now - Date.parse(cellValue.copyStartedAt) < FILES_CELL_COPY_TTL_MS
}

export function withoutFilesCopyMarker<T extends {isBeingCopied?: boolean, copyStartedAt?: string}>(value: T | null | undefined): Omit<T, 'isBeingCopied' | 'copyStartedAt'> | null {
  if(!value) {
    return null
  }
  const {isBeingCopied, copyStartedAt, ...rest} = value
  return rest
}
